import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "er-container wrapper m-y-8 flow information" }
const _hoisted_2 = { class: "body-font-l" }
const _hoisted_3 = { class: "flow-horizontal" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "button button--cta-primary button--big" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "button button--secondary button--big" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import constants from '../config/constants';
import configHelper from '../helpers/configHelper';
import languageHelper from '../helpers/languageHelper';
import { useAuthentication } from '../hooks';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isLoggedIn, isStaff } = useAuthentication();
const route = useRoute();

/** Dynamic error message depending on error passed via search query and login/staff status
 * @returns translation shortcut for i18n
 */
const errorMessage = computed(() => {
  // Only return the error code, if it is present and known to us
  if (route.query.error && constants.knownErrors.includes(route.query.error.toString())) {
    return route.query.error.toString();
  }

  // Return custom error message, if user is logged in but not a staff member
  if (isLoggedIn.value && !isStaff.value) return 'authFailed_staffPrompt';

  return 'authFailed_prompt';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('authFailed_heading')), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t(_unref(errorMessage))), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        style: {"border":"0"},
        href: `${_unref(configHelper).PDB_API}/myerco/auth/form_login/${_unref(languageHelper).getLanguage()}`
      }, [
        _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.$t('login')), 1)
      ], 8, _hoisted_4),
      _createElementVNode("a", {
        style: {"border":"0"},
        href: _ctx.$route.query.origin?.toString() || '/'
      }, [
        _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.$t('reloadPage')), 1)
      ], 8, _hoisted_6)
    ])
  ]))
}
}

})